import React, { ChangeEvent } from 'react';

import { classNames } from '@/helpers/classNames';
import {
	InputAdornment,
	OutlinedInputProps,
	SvgIcon,
	TextField,
	TextFieldProps,
} from '@material-ui/core';

import { error as exclamationIcon } from '../../../../assets/icons';
import inputStyles from '../Input.module.scss';
import styles from './FormInput.module.scss';

export type FormInputProps = {
	id: string;
	name: string;
	type?: string;
	placeholder?: string;
	fullWidth?: boolean;
	startAdornment?: React.ReactNode;
	endAdornment?: React.ReactNode;
	disabled?: boolean;
	autoComplete?: string;
	error?: boolean;
	value?: string;
	className?: string;
	label?: string;
	inputClassName?: string;
	onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
	withBorder?: boolean;
} & Pick<TextFieldProps, 'onChange' | 'onFocus' | 'onBlur'>;

export const FormInput = ({
	id,
	type,
	startAdornment,
	endAdornment,
	fullWidth,
	error,
	className,
	label,
	inputClassName,
	withBorder,
	onClick,
	...rest
}: FormInputProps) => {
	let errorIcon;
	if (error) {
		errorIcon = (
			<InputAdornment position="end">
				<SvgIcon
					component={exclamationIcon}
					classes={{
						root: styles['form-input__icon'],
					}}
				/>
			</InputAdornment>
		);
	}

	const inputIcon = endAdornment ?? errorIcon;
	return (
		<div className={styles['root']}>
			{!!label && (
				<div className={styles['form-input__label']}>{label}</div>
			)}
			<TextField
				id={id}
				className={classNames([
					styles['form-input'],
					error && styles['error'],
					withBorder && styles['with-border'],
					className,
				])}
				type={type}
				fullWidth={fullWidth}
				onClick={onClick}
				InputProps={
					{
						className: styles['form-input__container'],
						disableUnderline: true,
						startAdornment: startAdornment,
						endAdornment: inputIcon,
					} as Partial<OutlinedInputProps>
				}
				inputProps={{
					className: classNames([
						inputStyles.input,
						styles['form-input__input'],
						inputClassName,
					]),
				}}
				{...rest}
			/>
			{!!onClick && (
				<div className={styles['overlay']} onClick={onClick} />
			)}
		</div>
	);
};
